import { dedupeHead, isArray, isString } from '@vuepress/shared';
import { inject } from 'vue';
/**
 * Injection key for page head
 */
export const pageHeadSymbol = Symbol(__VUEPRESS_DEV__ ? 'pageHead' : '');
/**
 * Returns the ref of the head config of current page
 */
export const usePageHead = () => {
    const pageHead = inject(pageHeadSymbol);
    if (!pageHead) {
        throw new Error('usePageHead() is called without provider.');
    }
    return pageHead;
};
/**
 * Merge the head config in frontmatter and site locale
 *
 * Frontmatter should take priority over site locale
 */
export const resolvePageHead = (headTitle, frontmatter, siteLocale) => {
    const description = isString(frontmatter.description)
        ? frontmatter.description
        : siteLocale.description;
    const head = [
        ...(isArray(frontmatter.head) ? frontmatter.head : []),
        ...siteLocale.head,
        ['title', {}, headTitle],
        ['meta', { name: 'description', content: description }],
    ];
    return dedupeHead(head);
};
